import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { OnDestroy } from '@angular/core';
import { ComponentBase } from '../../../../views/component-base';
import {
  commomState_ElevatedAccess,
  commomState_LoggedinInfo,
} from 'src/app/store/common/common.selectors';
import { AppState } from 'src/app/store/app.states';
import { RouterLink } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { FeatureToggleName } from 'src/app/model/feature-toggle-name.model';
import { NgIf, AsyncPipe, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { FeatureToggleDirective } from '../../directives/feature-toggle.directive';
import { AuthHelperService } from 'src/app/services/authHelper.service';
import { AnimateCssDirective } from '../../directives/animatecss.directive';
import { ClickOutsideDirective } from '../../directives/appClickOut.directive';

@Component({
  selector: 'app-user-top-dropdown',
  templateUrl: './user-top-dropdown.component.html',
  styleUrls: ['./user-top-dropdown.component.scss'],
  imports: [
    FeatureToggleDirective,
    TranslatePipe,
    NgIf,
    MatIcon,
    AsyncPipe,
    RouterLink,
    NgClass,
    AnimateCssDirective,
    ClickOutsideDirective
  ],
})
export class UserTopDropdownComponent
  extends ComponentBase
  implements OnInit, OnDestroy
{
  loggedInUser$ = this.store.pipe(select(commomState_LoggedinInfo));
  elevatedAccess$ = this.store.pipe(select(commomState_ElevatedAccess));
  changePasswordFeatureToggle = FeatureToggleName.member.changePassword.view;

  opened: boolean = false;

  constructor(
    public store: Store<AppState>,
    private authHelper:AuthHelperService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInitBase();
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }
  
  async signout() {
    await this.authHelper.logoutRedirect();
  }

  toggleDropdown() {
    this.opened = !this.opened;
  }

  closeDropdown() {
    this.opened = false;
  }
}
